import { CookedProduct, isCustomDonationFundItemNoGoal, isGroupGiftPurchasedAsPhysical } from '@apps/registry/common/selectors/ProductListSelector';

export const isProductStillNeeded = (product: CookedProduct) => {
  return !((product.stillNeeded <= 0 && !isCustomDonationFundItemNoGoal(product)) || isGroupGiftPurchasedAsPhysical(product));
};
